// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".def-video[data-v-bcafc82a]{height:auto;max-width:100%}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/Def/DefVideo/DefVideo.vue"],"names":[],"mappings":"AAAA,4BAA0B,WAAA,CAAf,cAGX","sourcesContent":[".def-video{max-width:100%;height:auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
